module.exports = __webpack_public_path__ + "img/banbif.58f4f7ed.jpg";